// SIM NATION — Deal of the Week: live text mirror of homepage Bundle of the Week
// Fetches "/" at load time, parses the returned HTML, and pulls the first
// .bcard (bundle card) it finds — price, savings, link. The background
// image is fixed and never depends on this data.
(function () {
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-sdw-root]');
    if (!root) return;

    fetch('/')
      .then(function (res) {
        if (!res.ok) throw new Error('homepage fetch failed');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var firstCard = doc.querySelector('.bcard');
        if (!firstCard) return;

        var nameEl = firstCard.querySelector('.bcard__name');
        var priceNowEl = firstCard.querySelector('.bcard__price-now');
        var priceWasEl = firstCard.querySelector('.bcard__price-was');
        var savingsEl = firstCard.querySelector('.bcard__savings-badge');
        var btnEl = firstCard.querySelector('.bcard__btn');

        var name = nameEl ? nameEl.textContent.trim() : '';
        if (!name) return;

        var priceNow = priceNowEl ? priceNowEl.textContent.trim() : '';
        var priceWas = priceWasEl ? priceWasEl.textContent.trim() : '';
        var savings = savingsEl ? savingsEl.textContent.trim() : '';
        var link = btnEl ? btnEl.getAttribute('href') : '/pages/shop';

        var taglineHtml = '';
        if (priceNow) taglineHtml += escapeHtml(priceNow);
        if (priceWas) taglineHtml += ' <s>' + escapeHtml(priceWas) + '</s>';
        if (savings) taglineHtml += (taglineHtml ? ' — ' : '') + escapeHtml(savings);

        var taglineTarget = root.querySelector('[data-sdw-tagline]');
        var linkTarget = root.querySelector('[data-sdw-link]');

        if (taglineTarget) taglineTarget.innerHTML = taglineHtml;
        if (linkTarget && link) linkTarget.setAttribute('href', link);

        root.style.display = '';
      })
      .catch(function () {
        // Fetch or parse failed — leave the card hidden rather than show broken content
      });
  });
})();
